import { api } from '../../../services/api/client';
import type { SiteSettings } from '../../../types';

export async function fetchPublicSettings(): Promise<SiteSettings> {
  const { data } = await api.get<SiteSettings>('/public/settings');
  return data;
}
export async function adminGetSettings(): Promise<SiteSettings> {
  const { data } = await api.get<SiteSettings>('/admin/settings');
  return data;
}
export async function adminUpdateSettings(payload: Partial<SiteSettings>): Promise<SiteSettings> {
  const { data } = await api.put<SiteSettings>('/admin/settings', payload);
  return data;
}
